import { Fund, FundOverrideItem } from "~/models/fund";
import { findFundOverrideImage } from "~/utils/fund";
import { ListContainer } from "~/common/list/ListContainer";
import { FundItemList } from "./funditem/FundItemList";
import { FundViewTitle } from "./FundViewTitle";

export const FundListView = ({
  title,
  fundOverrides,
  nonprofits,
  onClick,
}: {
  title?: string;
  fundOverrides: FundOverrideItem[];
  nonprofits?: Fund[];
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
}) => {
  return (
    <ListContainer>
      <FundViewTitle title={title} onClick={onClick} />

      <div className="tw:flex tw:flex-col">
        {nonprofits?.map((nonprofit: Fund) => (
          <FundItemList
            key={nonprofit.ein}
            ein={nonprofit.ein}
            name={nonprofit.name}
            donationWeight={nonprofit.donation_weight}
            description={nonprofit.nonprofit_response}
            imageId={findFundOverrideImage(fundOverrides, nonprofit.ein)}
          />
        ))}
      </div>
    </ListContainer>
  );
};
